export default __webpack_public_path__ + "static/media/GoGroup.08d6439a.webp";